import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { QRCodeCanvas } from "qrcode.react";
import { toast } from "sonner";
import { Copy, ExternalLink, Tablet } from "lucide-react";

const UnitTotem = ({ unit }) => {
  const url = `${window.location.origin}/totem/${unit.id}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("Link copiado"); }
    catch { toast.error("Não foi possível copiar — selecione o link manualmente"); }
  };
  return (
    <Card className="p-4 flex gap-4 items-center" data-testid={`totem-unit-${unit.id}`}>
      <QRCodeCanvas value={url} size={112} includeMargin data-testid={`totem-qr-${unit.id}`} />
      <div className="min-w-0 flex-1 space-y-2">
        <div className="font-heading font-black text-slate-900 uppercase">{unit.name}</div>
        <div className="text-xs font-mono break-all text-slate-600 select-all" data-testid={`totem-url-${unit.id}`}>{url}</div>
        <div className="flex gap-2 flex-wrap">
          <Button size="sm" variant="outline" onClick={copy} data-testid={`totem-copy-${unit.id}`}><Copy className="w-4 h-4 mr-1"/>Copiar link</Button>
          <Button size="sm" variant="outline" asChild data-testid={`totem-open-${unit.id}`}>
            <a href={url} target="_blank" rel="noreferrer"><ExternalLink className="w-4 h-4 mr-1"/>Abrir</a>
          </Button>
        </div>
      </div>
    </Card>
  );
};

export const TotemLinks = () => {
  const [units, setUnits] = useState([]);
  useEffect(() => { api.get("/units").then(({ data }) => setUnits(data || [])).catch(() => toast.error("Falha ao carregar unidades")); }, []);
  return (
    <div className="space-y-4" data-testid="totem-links">
      <Card className="p-4 text-sm text-slate-600 flex gap-3">
        <Tablet className="w-5 h-5 shrink-0 text-slate-700"/>
        <div>Aponte a câmera do tablet para o QR Code da unidade (ou abra o link). No navegador, toque em <b>"Adicionar à tela inicial"</b> / <b>"Instalar app"</b> e abra pelo ícone: o totem roda em tela cheia, sem login, já com os planos da unidade.</div>
      </Card>
      <div className="grid md:grid-cols-2 gap-4">
        {units.map((u) => <UnitTotem key={u.id} unit={u}/>)}
      </div>
      {!units.length && <div className="text-sm text-slate-500">Nenhuma unidade cadastrada.</div>}
    </div>
  );
};
